module.exports = __webpack_public_path__ + "img/0a268b2.jpg";